import React from 'react';
import {
  EmptyState,
  Bullseye
} from '@patternfly/react-core';
import CubesIcon from '@patternfly/react-icons/dist/esm/icons/cubes-icon';

export const EmptyStateBasic = () => (
  <Bullseye>
    <EmptyState
      headingLevel="h4"
      titleText="Pusty stan"
      icon={CubesIcon}
    />
  </Bullseye>
);

export default EmptyStateBasic;